import { Form, Formik } from "formik";
import { FC, useState } from "react";
import { Button } from "../../../utils/Button";
import ArrayInput from "../../../utils/form/ArrayInput";
import {  propsInterfaceFormGroupInput } from "../../../utils/form/FormGroupInput";
const MinutaC: FC = () => {
    const columInput = 3;
    const [inputs, setInputs] = useState<propsInterfaceFormGroupInput[]>([
        {
            columInput:columInput,
            type: "text",
            campo: "name",
            label: "Nombre",
            placeholder: "Ingrese nombre",
            onBlur: (e,setFieldValue) => {
                setFieldValue("name","solo pedro")
            }
        },
        {
            columInput:columInput,
            type: "number",
            campo: "edad",
            label: "Edad",
            placeholder: "Ingrese edad",
            onBlur: (e) => {
                let inp = inputs.slice();
                let data = inp.map((item) => {
                    if (item.campo === "fechaNacimiento") {
                        if (e.target.value !== "") {
                            let edad = parseInt(e.target.value)
                            if (edad > 17) {
                                item.hideInput = false
                            }else{
                                alert("solo se puede ingresar mayores de 18 años")
                                item.hideInput = true
                            }
                        }
                    }
                    return item;
                })
                
                setInputs(data)
            }
        },
        {
            columInput:columInput,
            type: "date",
            hideInput: true,
            campo: "fechaNacimiento",
            label: "Fecha Nacimiento",
            placeholder: "Ingrese Fecha Nacimiento"
        },
        {
            columInput:1,
            campo: "service",
            label: "Servicio",
            type: "autocomplete",
            advanceOptions: {
                id: "service-input",
                multiple: false,
                placeholder:"Ingrese servicio",
                options: [
                    { text: "Desayuno", value: "1" },
                    { text: "Almuerzo", value: "2" },
                    { text: "Once", value: "3" },
                    { text: "Cena", value: "4" }
                ]
            },
            className: "form-control b-0 p-0 form-control-lg input-contract"
        }
    ])
    const initValue: IMinutaC = {
        name: "Jose",
        edad: 25,
        fechaNacimiento: new Date(),
        service:[]
    }
    return (
        <>
            <h2>Hola mundo</h2>
            <Formik
                initialValues={initValue}
                onSubmit={(value) => {
                }}
            >
                {(FormikProps) => (
                    <Form>
                        <ArrayInput
                            arrayInput={inputs}
                        />
                        <Button
                            type="submit"
                        >Enviar</Button>
                    </Form>
                )}

            </Formik>
        </>
    )
}
interface IMinutaC {
    name: string,
    edad?: number,
    fechaNacimiento?: Date,
    service?:any,
    onBlur?(e: React.ChangeEvent<HTMLInputElement>): void
}
export { MinutaC }